
/* 
  Created by:Upendram Reddy Tanuja
  Created on: 21-Aug-19 07:30 PM
  Purpose: User Password Manager Service Page
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PasswordManagerService {
  //api_url: string = "http://192.168.0.128:9001/api/api/";
  //  api_url: string = "http://192.168.0.141:9001/api/UserPassword/";
  api_url: string = environment.SERVER_URL + "UserPassword/";

  // api_url: string = "../assets.options.json"
  constructor(private http: HttpClient) {

  }
  getPasswordStatus(user_id) {
    return this.http.get(this.api_url + 'LinkExpiry', { params: { user_id: user_id } });
  }


  saveDetails(user_id, obj) {
    return this.http.post(this.api_url + 'Data', obj, { params: { user_id: user_id } });

  }
}